export default function Divider({ blok, a11yHidden = false }) {
  return (
    <div className={`content-divider bg-${blok?.background}`} aria-hidden={a11yHidden}>
      <div className="max-w-screen-xl mx-auto relative">
        <hr className="block w-full mx-auto border-t-0 h-4 divider" />
      </div>
    </div>
  )
}
